import React from 'react';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
import ChaptersContainer from '../../../Containers/AdminContainer/Chapters';

const ChapterScreen = () => {
  return <ChaptersContainer />;
};

export default ChapterScreen;
